import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57c76cc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-2" }
const _hoisted_2 = { class: "fw-bold mb-5 fs-6" }
const _hoisted_3 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_4 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_5 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_6 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_7 = { class: "col-lg-10" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_11 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_12 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_13 = { class: "col-lg-10" }
const _hoisted_14 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_15 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_16 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_17 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_18 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_19 = { class: "col-lg-10 d-flex" }
const _hoisted_20 = { class: "form-check me-4 my-auto" }
const _hoisted_21 = {
  class: "form-check-label",
  for: "public2"
}
const _hoisted_22 = { class: "form-check my-auto" }
const _hoisted_23 = {
  class: "form-check-label",
  for: "private2"
}
const _hoisted_24 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_25 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_26 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_27 = { class: "col-lg-10 d-flex align-items-center" }
const _hoisted_28 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_29 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_30 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_31 = { class: "col-lg-10 d-flex align-items-center" }
const _hoisted_32 = { class: "d-flex" }
const _hoisted_33 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_34 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_35 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_36 = { class: "col-lg-10 d-flex align-items-center" }
const _hoisted_37 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_38 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_39 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_40 = { class: "col-lg-10 d-flex align-items-center" }
const _hoisted_41 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_42 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_43 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_44 = { class: "col-lg-10 d-flex align-items-center" }
const _hoisted_45 = { class: "d-flex justify-content-center" }
const _hoisted_46 = { class: "bg-white rounded-4 shadow p-4 mb-2" }
const _hoisted_47 = { class: "fw-bold mb-4 fs-6" }
const _hoisted_48 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-2 gx-3 mb-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-max-content col-lg-3 col-form-label" }, null, -1))
const _hoisted_50 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-right-pointing-triangle" }, null, -1))
const _hoisted_52 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_53 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_54 = { class: "fw-bold mb-5 fs-6" }
const _hoisted_55 = { class: "d-flex justify-content-center" }
const _hoisted_56 = {
  class: "modal fade",
  id: "confirmEditModal",
  tabindex: "-1",
  "aria-labelledby": "confirmEditModal",
  "aria-hidden": "true"
}
const _hoisted_57 = { class: "modal-dialog modal-lg" }
const _hoisted_58 = ["onSubmit"]
const _hoisted_59 = { class: "modal-content" }
const _hoisted_60 = { class: "modal-header" }
const _hoisted_61 = {
  class: "modal-title text-center fw-bold w-100",
  id: "editModalHeader"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_63 = { class: "modal-body" }
const _hoisted_64 = { class: "row px-3 px-md-5 mt-3 border-bottom" }
const _hoisted_65 = { class: "col-lg-3 fw-bold" }
const _hoisted_66 = { class: "col-lg-8" }
const _hoisted_67 = { class: "text-break break-spaces" }
const _hoisted_68 = { class: "row px-3 px-md-5 mt-3 border-bottom" }
const _hoisted_69 = { class: "col-lg-3 fw-bold" }
const _hoisted_70 = { class: "col-lg-9 gx-0 mx-0 d-flex fs-7" }
const _hoisted_71 = { class: "me-2" }
const _hoisted_72 = { class: "me-2" }
const _hoisted_73 = { class: "row px-3 px-md-5 mt-3 border-bottom" }
const _hoisted_74 = { class: "col-lg-3 fw-bold" }
const _hoisted_75 = { class: "col-lg-8" }
const _hoisted_76 = { class: "text-break break-spaces" }
const _hoisted_77 = { class: "row px-3 px-md-5 mt-3 border-bottom" }
const _hoisted_78 = { class: "col-lg-3 fw-bold" }
const _hoisted_79 = { class: "col-lg-8" }
const _hoisted_80 = { class: "text-break break-spaces" }
const _hoisted_81 = { class: "row px-3 px-md-5 mt-3" }
const _hoisted_82 = { class: "col-lg-3 fw-bold" }
const _hoisted_83 = { class: "col-lg-8" }
const _hoisted_84 = { class: "text-break break-spaces" }
const _hoisted_85 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_86 = {
  class: "modal fade",
  id: "editGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "editGroupSuccess",
  "aria-hidden": "true"
}
const _hoisted_87 = { class: "modal-dialog" }
const _hoisted_88 = { class: "modal-content" }
const _hoisted_89 = { class: "modal-header" }
const _hoisted_90 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmModalHeader"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_92 = { class: "" }
const _hoisted_93 = { class: "text-center my-4" }
const _hoisted_94 = { class: "d-flex justify-content-center modal-footer" }

import Status from '@/components/status/index.vue'
import Loading from '@/components/loading/index.vue'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { translate } from '@/languages/i18n'
import { useRoute, useRouter } from 'vue-router'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import TableGroupUsers from './table-group-users/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import useVuelidate from '@vuelidate/core'
import { minLength, required } from '@vuelidate/validators'
import { REGEX_EMOJI } from '@/constants/regex'
import { customMaxLength, scrollToErrors } from '@/utils'
import groupsService from '@/services/groups.service'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { ConvertFromLocalTime } from '@/constants/datepicker'
import { Modal } from 'bootstrap'
import { GROUPS_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const detailGroup = computed(() => store.getters[GROUPS_STORE.GETTERS.DETAIL_GROUPS])
const talkroomList = ref({})

const loading = ref(false)
const buttonDisable = ref(false)
const editFailed = ref<boolean>(false)
const modalConfirmEditModal = ref()
const modalEditGroupSuccess = ref()

onMounted(() => {
  loading.value = true
  getDetailGroup()
  getTalkRoomList()
  modalConfirmEditModal.value = new Modal(document.getElementById('confirmEditModal'))
  modalEditGroupSuccess.value = new Modal(document.getElementById('editGroupSuccess'))
})

const getDetailGroup = async () => {
  const params = {
    create_by_admin: true,
  }
  await store.dispatch(GROUPS_STORE.ACTIONS.SET_DETAIL_GROUPS, { group_id: route?.params?.group_id, params })
}

const getTalkRoomList = async () => {
  const params = {
    create_by_admin: true,
    get_all_data: true,
  }
  try {
    const response = await groupsService.getListTalkRoom(route?.params?.group_id, params)
    if (response?.status === 200) {
      talkroomList.value = response?.data
    } else if (response?.response?.status === 404) {
      router.push('/404')
    }
  } catch (error) {
    console.log(error)
  } finally {
    loading.value = false
  }
}

const backToList = () => {
  const previousUrlArray = router.options.history.state.back?.split('/')
  if (previousUrlArray?.pop().split('?')[0] === 'groups' && previousUrlArray?.pop() === 'admin') {
    router.go(-1)
  } else {
    router.push(`/community/communities/${route.params?.id}/admin/groups?created_at=desc`)
  }
}

const fullContent = ref<boolean>(false)
const SeeMore = () => {
  fullContent.value = true
}

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/${route.path.split('/')[1]}/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('groupManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('listGroup'),
    to: `/${route.path.split('/')[1]}/communities/${route.params?.id}/admin/groups?created_at=desc`,
    active: false,
  },
  {
    content: translate('communityEditGroup'),
    to: '',
    active: true,
  },
]

const rules = computed(() => {
  return {
    name: {
      required,
      minLength: minLength(1),
      maxLength: (value: string) => customMaxLength(value, 30),
    },
    information: {
      maxString: (value: string) => customMaxLength(value, 200),
    },
    published: {},
  }
})

const formData = ref({
  name: '',
  information: '',
  published: true,
})

watch(
  () => detailGroup.value,
  () => {
    formData.value = {
      name: detailGroup.value?.name,
      information: detailGroup.value?.information,
      published: detailGroup.value?.published,
    }
  }
)

const v$ = useVuelidate(rules, formData)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  loading.value = true
  isCheckedNGKeyName.value = false
  isCheckedNGKeyInfo.value = false
  await checkNGKeyName()
  await checkNGKeyInfo()
  while (!isCheckedNGKeyName.value || !isCheckedNGKeyInfo.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v$.value.$invalid || ngKeyName.value || ngKeyInfo.value) {
    loading.value = false
    nextTick(() => {
      scrollToErrors()
    })
    return
  }
  modalConfirmEditModal.value.show()
  loading.value = false
}

const editGroup = async (): Promise<void> => {
  buttonDisable.value = true
  try {
    formData.value.create_by_admin = true
    const response = await groupsService.editGroupApi(route?.params?.group_id, formData.value)
    if (response?.status === 200) {
      await getDetailGroup()
      editFailed.value = false
      buttonDisable.value = false
    } else {
      editFailed.value = true
    }
  } catch (error) {
    buttonDisable.value = false
    console.log(error)
    editFailed.value = true
  }
  modalConfirmEditModal.value.hide()
  modalEditGroupSuccess.value.show()
}

const isCheckedNGKeyName = { value: false }
const ngKeyName = ref<boolean>(false)
const checkNGKeyName = debounce(async () => {
  const queryData = { sentence: v$.value.name.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyName.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyName.value = true
  }
}, 200)

const isCheckedNGKeyInfo = { value: false }
const ngKeyInfo = ref<boolean>(false)
const checkNGKeyInfo = debounce(async () => {
  const queryData = { sentence: v$.value.information.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyInfo.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyInfo.value = true
  }
}, 200)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('communityEditGroup')), 1),
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)('groupName')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "name",
                class: _normalizeClass(['form-control', ngKeyName.value || _unref(v$).name.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyName) && _unref(checkNGKeyName)(...args))),
                placeholder: _unref(translate)('placeholder'),
                rows: "4"
              }, null, 42, _hoisted_8), [
                [
                  _vModelText,
                  _unref(v$).name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyName.value && !_unref(v$).name.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('groupName'),
                validator: _unref(v$).name.$errors[0]?.$validator,
                params: [1, 30]
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)('explanatoryText')), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                name: "information",
                class: _normalizeClass(['form-control', ngKeyInfo.value || _unref(v$).information.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).information.$model) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyInfo) && _unref(checkNGKeyInfo)(...args))),
                rows: "5"
              }, null, 34), [
                [
                  _vModelText,
                  _unref(v$).information.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyInfo.value && !_unref(v$).information.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('explanatoryText'),
                validator: _unref(v$).information.$errors[0]?.$validator,
                params: [200]
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('publicSettings')), 1),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault",
                    id: "public2",
                    value: true,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).published.$model) = $event))
                  }, null, 512), [
                    [_vModelRadio, _unref(v$).published.$model]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('public')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault",
                    id: "private2",
                    value: false,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).published.$model) = $event))
                  }, null, 512), [
                    [_vModelRadio, _unref(v$).published.$model]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('private')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(translate)('inviteOnlyGroupSettings')), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(detailGroup).invitation_group ? _unref(translate)('inviteOnlyGroup') : _unref(translate)('generalGroup')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('managementNo')), 1),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(UserAliasIcon, {
                userType: _unref(detailGroup)?.admin?.user_type
              }, null, 8, ["userType"]),
              _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(detailGroup)?.admin?.management_no), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(translate)('creator')), 1),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(detailGroup)?.admin?.family_name + ' ' + _unref(detailGroup)?.admin?.given_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(translate)('registrationDate')), 1),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(ConvertFromLocalTime)(_unref(detailGroup)?.created_at)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(translate)('lastUpdateTime')), 1),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(ConvertFromLocalTime)(_unref(detailGroup)?.updated_at)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createVNode(Button, {
            title: _unref(translate)('update'),
            type: "secondary",
            onClick: onSubmit,
            disabled: loading.value,
            loading: loading.value,
            className: "fw-bold"
          }, null, 8, ["title", "disabled", "loading"])
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("h5", _hoisted_47, _toDisplayString(_unref(translate)('listTalkrooms')), 1),
      _createElementVNode("div", _hoisted_48, [
        _hoisted_49,
        _createElementVNode("div", _hoisted_50, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fullContent.value ? talkroomList.value?.data : talkroomList.value?.data?.slice(0, 5), (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: "black-link cursor-pointer col-lg-10 mb-2",
              key: item?.id,
              to: `/community/communities/${_unref(route).params?.id}/admin/groups/${_unref(route).params?.group_id}/talkrooms/${item.id}`
            }, {
              default: _withCtx(() => [
                _hoisted_51,
                _createTextVNode(" " + _toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128)),
          (talkroomList.value?.data?.length > 5 && !fullContent.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "text-decoration-underline cursor-pointer",
                onClick: SeeMore
              }, _toDisplayString(_unref(translate)('seeMore')), 1))
            : _createCommentVNode("", true)
        ]),
        (talkroomList.value?.data?.length === 0 && !loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_unref(translate)('OE65noData')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("h5", _hoisted_54, _toDisplayString(_unref(translate)('OE10listUser')), 1),
      _createVNode(TableGroupUsers),
      _createElementVNode("div", _hoisted_55, [
        _createVNode(Button, {
          title: _unref(translate)('back'),
          type: "secondary",
          onClick: backToList
        }, null, 8, ["title"])
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(editGroup, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("h5", _hoisted_61, _toDisplayString(_unref(translate)('groupEditting')), 1),
              _hoisted_62
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(translate)('groupName')), 1),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("p", _hoisted_67, _toDisplayString(formData.value.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, _toDisplayString(_unref(translate)('creator')), 1),
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(UserAliasIcon, {
                    userType: _unref(detailGroup)?.admin?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("p", _hoisted_71, _toDisplayString(_unref(detailGroup)?.admin?.management_no), 1),
                  _createElementVNode("p", _hoisted_72, _toDisplayString(_unref(detailGroup)?.admin?.family_name + ' ' + _unref(detailGroup)?.admin?.given_name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, _toDisplayString(_unref(translate)('explanatoryText')), 1),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("p", _hoisted_76, _toDisplayString(formData.value.information), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, _toDisplayString(_unref(translate)('publicSettings')), 1),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("p", _hoisted_80, _toDisplayString(formData.value.published ? _unref(translate)('public') : _unref(translate)('private')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, _toDisplayString(_unref(translate)('inviteOnlyGroupSettings')), 1),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("p", _hoisted_84, _toDisplayString(_unref(detailGroup).invitation_group ? _unref(translate)('inviteOnlyGroup') : _unref(translate)('generalGroup')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                class: "me-lg-3",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('update'),
                type: "secondary",
                loading: buttonDisable.value,
                disabled: buttonDisable.value,
                htmlType: "submit",
                className: "fw-bold"
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ], 40, _hoisted_58)
      ])
    ]),
    _createElementVNode("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("h5", _hoisted_90, _toDisplayString(_unref(translate)('groupEditting')), 1),
            _hoisted_91
          ]),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("p", _hoisted_93, _toDisplayString(editFailed.value ? _unref(translate)('errorEditGroup') : _unref(translate)('OC47updateComplete')), 1)
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: "secondary",
              "data-bs-dismiss": "modal",
              className: "fw-bold"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})